import { Box } from '@mui/joy';
import Sidebar from '../components/Sidebar';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar sx={{ width: 350}} />
      <Box sx={{ flexGrow: 1, p: 2, width: '100%' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;